import { Flash } from '@carbon/icons-react';
import classNames from 'classnames';
import { ConnectionInfo } from 'portal-sdk';
import * as React from 'react';

import { NavbarAside } from 'bones/components/molecules/Navbar/NavbarAside';
import { usePortalConnectionItems } from 'bones/components/molecules/Portal/hooks/usePortalConnectionItem';
import { Button } from 'bones/design-system/components/Button';
import { Selector } from 'bones/design-system/components/select/Selector';
import { PortalConnection } from 'bones/utils/portal/usePortalConnectionByIndex';

export interface PortalEndpointAsideProps {
  connectionInfo?: ConnectionInfo;
  copy: {
    manageEndpoints: string;
    selector: string;
  };
  onManageEndpoints: () => void;
  onSelectConnection: (connection: PortalConnection) => void;
  testIds: {
    manageEndpoints: string;
    selector: string;
    selectorItem: (id: string, idx?: number) => string;
  };
}

export const PortalEndpointAside: React.VFC<PortalEndpointAsideProps> = ({
  connectionInfo,
  copy,
  onManageEndpoints,
  onSelectConnection,
  testIds,
}) => {
  const { connections, connectionItems, connectionItem } =
    usePortalConnectionItems(connectionInfo?.connectionIndex);

  return (
    <>
      <NavbarAside className="vb-portal-endpoint-aside" title="Endpoint">
        <div className="vb-navbar-aside-divider" />
        <div className="vb-navbar-aside-content">
          <Selector.Single
            className="vb-navbar-aside-selector"
            inputProps={{
              icon: Flash,
              label: copy.selector,
              size: 'lg-outside',
              testId: testIds.selector,
              value: connectionItem?.text,
            }}
            items={connectionItems}
            itemTestId={testIds.selectorItem}
            onSelect={(item) => {
              // istanbul ignore if
              if (!item) {
                return;
              }

              const connection = connections.data?.find(
                (connection) => connection.index === item.index
              );

              // istanbul ignore else
              if (connection) {
                onSelectConnection(connection);
              }
            }}
            popoverProps={{
              popoverClassName: 'vb-navbar-aside-selector-popover',
            }}
            selected={connectionItem}
          />
        </div>
        <div className="vb-navbar-aside-divider" />
        <div
          className={classNames(
            'vb-navbar-aside-content',
            'vb-navbar-aside-content--center'
          )}
        >
          <Button
            className="vb-portal-endpoint-aside-manage-endpoints-button"
            onClick={onManageEndpoints}
            size="md"
            testId={testIds.manageEndpoints}
            variant="ghost-gray"
          >
            {copy.manageEndpoints}
          </Button>
        </div>
      </NavbarAside>
    </>
  );
};
